import { Navigate, useSearchParams } from "react-router-dom";

export default function VerifyEmailLegacyRedirect() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return <Navigate to={`/login?verifyEmailToken=${encodeURIComponent(token)}`} replace />;
}
